import { Divider, Typography, Box, Grid2, Button } from "@mui/material";

export default function AdmPaymentInfo({payment, close}) {
    const gridItemSize = {xs: 12, xl: 6};
 
    return (
        <Box sx={{display: 'flex', flexDirection: 'column', px: 2}}>
            <Typography variant="h6" align="center" color="focus" sx={{my: 2 }}>Informations de paiement</Typography>

            <Typography variant="subtitle1" gutterBottom>{payment.event?.titre}</Typography> 
                
            <Grid2 container spacing={1} mb={2}>
                <Grid2 size={gridItemSize}>
                    <Typography variant="body1">Montant du paiement: <span style={{fontWeight:500}}>{payment.amount?.toFixed(2)} €</span></Typography>
                </Grid2>
                <Grid2 size={gridItemSize}>
                    <Typography variant="body1">Frais ({payment.frais}%): {(Math.round(payment.recette * payment.frais) / 100).toFixed(2)} €</Typography>
                </Grid2>
                <Grid2 size={gridItemSize}>
                    <Typography variant="body1">Montant total: {payment.recette?.toFixed(2)} €</Typography>
                </Grid2>
                <Grid2 size={gridItemSize}>
                    <Typography variant="body1">Statut: <span style={{fontWeight:500}}>{payment.statut}</span></Typography>
                </Grid2>
            </Grid2>

            <Divider variant="middle" sx={{width: '60%', alignSelf:'center', mt:1, mb:2}}/>
            <Typography variant="subtitle1" align="center" gutterBottom>Informations bancaires (RIB)</Typography>

            <Grid2 container spacing={2} mb={2}>
                <Grid2 size={gridItemSize}>
                    <Typography variant="body1">Titulaire du compte: <span style={{textTransform:'capitalize'}}>{payment.rib?.titulaire}</span></Typography>
                </Grid2>

                <Grid2 size={gridItemSize}>
                    <Typography variant="body1">IBAN: <span style={{fontWeight:500}}>{payment.rib?.iban}</span></Typography>
                </Grid2>

                <Grid2 size={gridItemSize}>
                    <Typography variant="body1">BIC: <span style={{fontWeight:500}}>{payment.rib?.bic}</span></Typography>
                </Grid2>
            </Grid2>

            <Button variant="outlined" onClick={close} sx={{alignSelf: 'flex-end'}}>fermer</Button>

        </Box>
    );
}